import Vue from 'vue';
import OurPeople from 'scripts/vue/our-people/OurPeople.vue';
import OurPeopleCarousel from 'scripts/vue/our-people/OurPeopleCarousel.vue';

export default {
  init() {
    new Vue({
      el: '#app',
      name: 'app',
      components: {
        OurPeople,
        OurPeopleCarousel,
      },
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-our-people.js